<div class="moto_page">
    <div class="moto_details">
        <div class="moto_image" ><img style="width: 100px;" src="assets/svg/circle.svg" alt="moto"></div>
        <p class="moto_info">Great things in business are never done by one person. <span style="color: var(--primary-color);">They’re done by a team of people.</span></p>
    </div>
</div>